import type { SceneNodeItem } from "../scene/SceneNodeItem";
import type { SceneTreeNode } from "../scene/SceneTreeItem";

/**
 * Type guard to check if a SceneTreeNode is of dataType "element"
 * Overloads for both SceneTreeNode and SceneNodeItem
 */
export function isSceneElementNode(node: SceneNodeItem): node is SceneNodeItem<"element"> {
  return node.dataType === "element";
}

export function isElementTreeNode(treeNode: SceneTreeNode): treeNode is SceneTreeNode<"element"> {
  return treeNode.node.dataType === "element";
}
